<template>
  <div>
    <Header></Header>
    <div class="col-11 flex">
      <div>
        <div class="ms-3 d-flex mt-2">
          <h4 class="mt-1">Search user profile by email:</h4>
          <Multiselect v-model="searchEmail" placeholder="Search by email..." :searchable="true" :options="fetchSuggestions" :delay="200" :min-chars="2" :resolve-on-load="false" class="multiselect-blue start-0 ms-2" style="width: 300px" @select="onSelect" @deselect="onSelect" />
        </div>
        <div class="row">
          <div class="col-12 no-overflow ms-3 me-3 pt-3" style="position: relative;">
              <div class="user-info-item">
                <h2>User Profile for email: <strong> {{ email}}</strong></h2>
              </div>
              <div v-if="userData !== undefined" class="row">
              <div v-if="userData.emailSubscribe !== undefined" class="user-info-item">
                <strong>Email Subscribe:</strong> {{ userData.emailSubscribe }}
              </div>
              <div v-if="userData.region !== undefined" class="user-info-item">
                <strong>Region:</strong> {{ userData.region }}
              </div>
              <div v-if="userData.videoQuality !== undefined" class="user-info-item">
                <strong>Video Quality:</strong> {{ userData.videoQuality }}
              </div>
              <div class="user-info-item">
                <strong>Status:</strong> {{ userData.status }}
              </div>
              <div class="user-info-item">
                <strong>Active:</strong> {{ userData.active }}
              </div>
                <div class="user-info-item" @click="selectId(userData.userId)" style="cursor: pointer;">
                  <strong>User ID:</strong> {{ userData.userId }}
                </div>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-12 no-overflow ms-3 me-3 pt-3" style="position: relative;">
            <div class="d-flex align-items-center gap-2">
              <h2 class="mb-0">User Plans</h2>
              <div class="info-tooltip">
                <img class="info-img" src="@/assets/info.svg" alt="info" />
                <span class="info-name">Info</span>
                <div class="info-popover">
                  <div class="legend">
                    <div class="legend-row">
                      <span>
                        <strong>Payment Method</strong> detection order:
                        If <strong>cpayPayment</strong> is <strong>true</strong>, the method is <strong>CPay</strong>.
                        If <strong>squareOrderId</strong> is set and matches <strong>stripeInvoice</strong>, the method is <strong>Square</strong>.
                        Otherwise, if <strong>stripeInvoice</strong> starts with <strong>"in_"</strong>, the method is <strong>Stripe</strong>.
                        If <strong>paypalCaptureId</strong> matches <strong>stripeInvoice</strong>, the method is <strong>PayPal</strong>.
                        If <strong>plisioTxnId</strong> exists, it is <strong>Plisio</strong>. If not, it defaults to <strong>PayPal</strong>.
                        If <strong>stripeInvoice</strong> is null (and no cPay/Square indicators), the method is <strong>null</strong>.
                        <strong>Configuration ID</strong> is taken from the corresponding configuration field; if missing, the method is marked as an error.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>


              <div class="table-responsive">
                <table class="table table-striped table-bordered">
                  <thead>
                  <tr>
                    <th class="col-2" @click="toggleSort('userPlans', 'startDate')">Start Date</th>
                    <th class="col-2" @click="toggleSort('userPlans', 'endDate')">End Date</th>
                    <th class="col-1" @click="toggleSort('userPlans', 'couponCode')">Coupon Code</th>
                    <th @click="toggleSort('userPlans', 'trialActivationCode')">Trial Activation Code</th>
                    <th class="col-1" @click="toggleSort('userPlans', 'stripeInvoice')">Invoice</th>
                    <th class="col-1" @click="toggleSort('userPlans', 'paymentMethod')">Payment Method</th>
                    <th class="col-1" @click="toggleSort('userPlans', 'configurationId')">Conf. ID</th>
                    <th class="col-1" @click="toggleSort('userPlans', 'stripePaidAmount')">Paid Amount</th>
                    <th class="col-1" @click="toggleSort('userPlans', 'stripePaymentDate')">Payment Date</th>
                    <th @click="toggleSort('userPlans', 'status')">Status</th>
                    <th @click="toggleSort('userPlans', 'active')">Active</th>
                    <th class="col-1">Edit</th>
                    <th class="col-1">Refund</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="config in userPlansList" :key="config.userPlanId">
                    <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.startDate)" @click="selectText" :data-text="config.startDate"></td>
                    <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.endDate)" @click="selectText" :data-text="config.endDate"></td>
                    <td class="col-1 text-truncate" v-html="truncateText(config.couponCode, 30)" @click="selectText" :data-text="config.couponCode"></td>
                    <td class="col-1 text-truncate" v-html="truncateText(config.trialActivationCode, 30)" @click="selectText" :data-text="config.trialActivationCode"></td>
                    <td class="col-1 text-truncate" v-html="truncateText(config.stripeInvoice, 30)" @click="selectText" :data-text="config.stripeInvoice"></td>
                    <td class="col-1 text-truncate" v-html="truncateText(config.paymentMethod, 30)" @click="selectText" :data-text="config.paymentMethod"></td>
                    <td class="col-1 text-truncate" v-html="truncateText(config.configurationId, 30)" @click="selectText" :data-text="config.configurationId"></td>
                    <td class="col-1 text-truncate" v-html="truncateText(config.stripePaidAmount, 30)" @click="selectText" :data-text="config.stripePaidAmount"></td>
                    <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.stripePaymentDate)" @click="selectText" :data-text="config.stripePaymentDate"></td>
                    <td class="col-1 text-truncate" v-html="truncateText(config.status, 10)" @click="selectText" :data-text="config.status"></td>
                    <td class="col-1 text-truncate" v-html="truncateText(config.active, 10)" @click="selectText" :data-text="config.active"></td>
                    <td class="col-1 centered">
                      <router-link :to="{ name: 'UserPlanEdit', params: { id: config.userPlanId, ...config } }" class="procricket-btn">
                        Edit
                      </router-link>
                    </td>
                    <td class="col-1 centered">
                      <button v-if="config.active===true && config.status===true && config.stripePaidAmount!==undefined"
                              :disabled="config.paymentMethod === PaymentMethod.Plisio || config.paymentMethod === PaymentMethod.CPay"
                              class="procricket-btn" @click="openRefundModal(config.userPlanId)">Refund</button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <br>
              <vue-awesome-paginate
                  :total-items="totalElementsUserPlans"
                  :items-per-page="sizeUserPlans"
                  :max-pages-shown="5"
                  v-model="pageUserPlans"
                  :on-click="changePage"
              />
          </div>
        </div>
        <div class="row">
          <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
            <h2>Sessions</h2>
            <div class="d-flex justify-content-between align-items-center">
              <div class="items-per-page-dropdown mb-3">
                <label>Items Per Page: </label>
                <select v-model="sizeSession" @change="updateItemsPerPage">
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>

          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
              <tr>
                <th class="col-custom" @click="toggleSort('sessions','region')">Region</th>
                <th class="col-1" @click="toggleSort('sessions','edgeAddress')">Edge Address</th>
                <th class="col-1" @click="toggleSort('sessions','channelId')">Channel Name</th>
                <th class="col-1" @click="toggleSort('sessions','vidictId')">VidictId</th>
                <th class="col-1" @click="toggleSort('sessions','deviceOs')">Device Os</th>
                <th class="col-1" @click="toggleSort('sessions','deviceType')">Device Type</th>
                <th class="col-1" @click="toggleSort('sessions','appVersion')">App Version</th>
                <th class="col-1" @click="toggleSort('sessions','startTime')">Start Time</th>
                <th class="col-1" @click="toggleSort('sessions','endTime')">End Time</th>
               </tr>
              </thead>
              <tbody>
              <tr v-for="config in sessionList" :key="config.sessionId">
                <td class="col-custom text-truncate" v-html="truncateText(config.region, 10)" @click="selectText" :data-text="config.region"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.edgeAddress, 30)" @click="selectText" :data-text="config.edgeAddress"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.channelName, 10)"  @click="selectText" :data-text="config.channelName" ></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.vidictId, 50)" @click="selectText" :data-text="config.vidictId"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.deviceOs, 10)" @click="selectText" :data-text="config.deviceOs"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.deviceType, 10)"  @click="selectText" :data-text="config.deviceType" ></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.appVersion, 10)"  @click="selectText" :data-text="config.appVersion" ></td>
                <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.startTime)" @click="selectText" :data-text="config.startTime"></td>
                <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.endTime)" @click="selectText" :data-text="config.endTime"></td>
              </tr>
              </tbody>
            </table>
          </div>
          <br>
          <vue-awesome-paginate
              :total-items="totalElementsSessions"
              :items-per-page="sizeSession"
              :max-pages-shown="5"
              v-model="pageSessions"
              :on-click="changePage"
          />
        </div>
       </div>
        <div class="row">
          <div class="col-10 no-overflow ms-3 me-3 pt-3 ms-3" style="position: relative;">
          <h2>Devices</h2>
          <div class="d-flex align-items-center mb-2">
            <label class="me-2">Show only active</label>
            <input type="checkbox" v-model="showActiveDevicesOnly">
          </div>
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
              <tr>
                <th class="col-1" @click="toggleSort('devices','deviceName')">Device Name</th>
                <th class="col-1" @click="toggleSort('devices','deviceOs')">Device Os</th>
                <th class="col-1" @click="toggleSort('devices','deviceType')">Device Type</th>
                <th class="col-1" @click="toggleSort('devices','website')">Website</th>
                <th class="col-1" @click="toggleSort('devices','firstLoginAt')">First Login</th>
                <th class="col-1" @click="toggleSort('devices','lastSeenAt')">Last Seen</th>
                <th class="col-1" @click="toggleSort('devices','lastIp')">Last IP</th>
                <th class="col-1" @click="toggleSort('devices','active')">Active</th>
               </tr>
              </thead>
              <tbody>
              <tr v-for="config in filteredDeviceList" :key="config.deviceId">
                <td class="col-1 text-truncate" v-html="truncateText(config.deviceName, 50)" @click="selectText" :data-text="config.deviceName"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.deviceOs, 10)" @click="selectText" :data-text="config.deviceOs"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.deviceType, 10)"  @click="selectText" :data-text="config.deviceType" ></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.website, 20)"  @click="selectText" :data-text="config.website" ></td>
                <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.firstLoginAt)" @click="selectText" :data-text="config.firstLoginAt"></td>
                <td class="col-1 text-truncate" v-html="formatUnixTimestamp(config.lastSeenAt)" @click="selectText" :data-text="config.lastSeenAt"></td>
                <td class="col-1 text-truncate" v-html="truncateText(config.lastIp, 30)" @click="selectText" :data-text="config.lastIp"></td>
                <td class="col-1 text-truncate">
                  <span :class="config.active ? 'badge bg-success' : 'badge bg-secondary'">{{ config.active ? 'Active' : 'Signed out' }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        </div>

      </div>
    </div>
    <!-- Modal -->
    <div class="modal d-block" v-if="showRefund">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title fw-bold">Refund payment</h4>
            <button role="button" class="close close-modal" data-dismiss="modal" aria-label="Close" @click="closeRefundModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="modal-form">
              <label>Amount</label>
              <input type="text" v-model="refundAmount">
            </form>
            <div v-if="refundErrorMessage !== ''" class="error-message">{{refundErrorMessage}}</div>
            <div v-if="refundMessage !== ''" class="message">{{refundMessage}}</div>
          </div>
          <div class="modal-footer">
            <a class="btn cancel-btn" role="button" data-dismiss="modal" @click="closeRefundModal()">Cancel</a>
            <a class="btn signout-popup text-white" role="button" @click="refundUserPlan(true)">Internal Refund</a>
            <a class="btn signout-popup text-white" role="button" @click="refundUserPlan(false)">Refund to Customer</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import {
  UserRequest,
  Sort,
  UserFilter,
  SessionFilter,
  UserPlanFilter,
  UserPlanRequest, SessionRequest, RefundRequest, PaymentMethod
} from "@/model/models";
import {formatUnixTimestamp, truncateText, wrapText} from "@/utils/general-functions"
import router from "@/router";
import Multiselect from "@vueform/multiselect";

export default {
  name: "UserProfile",
  components: {
    Header,
    Multiselect
  },
  data() {
    return {
      refundUserPlanId: 0,
      refundAmount: 0.0,
      showRefund: false,
      refundErrorMessage: "",
      refundMessage: "",
      showSearch: false,
      page: 1,
      pageUserPlans: 1,
      pageSessions: 1,
      size: 20,
      sizeSession: 10,
      sizeUserPlans: 10,
      totalElementsUserPlans: 0,
      totalElementsSessions: 0,
      searchEmail: "",
      UsersList: [],
      userPlansList: [],
      deviceList: [],
      showActiveDevicesOnly: false,
      sessionList: [],
      sortColumn: null,
      sortColumnUserPlans: null,
      sortColumnSessions: null,
      email : this.$route.params.email,
      sortDirection: "ASC",
      sortDirectionUserPlans: "ASC",
      sortDirectionSessions: "ASC",
    };
  },
  computed: {
    PaymentMethod() {
      return PaymentMethod
    },
    filteredDeviceList() {
      return this.showActiveDevicesOnly
          ? this.deviceList.filter(d => d.active)
          : this.deviceList;
    },
    userData() {
      return this.UsersList[0];
    },
  },
  created() {
    this.doLoadData();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));
  },
  watch: {
    '$route.params.email'(newEmail) {
      this.email = newEmail;
      this.doLoadData();
    },
  },
  methods: {
    truncateText,
    wrapText,
    formatUnixTimestamp,
    async fetchSuggestions(query) {
      return await AdminService.suggestUsers(query);
    },
    openRefundModal(userPlanId) {
      this.refundUserPlanId = userPlanId
      this.showRefund = true
    },
    closeRefundModal() {
      this.refundUserPlanId = 0
      this.refundAmount = 0.0
      this.showRefund = false
    },
    refundUserPlan(isInternal) {
      this.refundErrorMessage = ""
      let refundRequest = new RefundRequest(this.refundUserPlanId, this.refundAmount)
      if (!isInternal) {
        refundRequest.reason = "requested_by_customer"
      }
      AdminService.refundUser(refundRequest).then((message) => {
        this.refundMessage = message
      }).catch((error) => {
        this.refundErrorMessage = error
      });
    },
    changePage(page) {
      this.page = page
      this.doLoadData()
    },
    doLoadData() {
      let requestUser = new UserRequest(
          0,
          1
      );
      if (this.sortColumn != null) {
        requestUser.sort = new Sort(this.sortColumn, this.sortDirection);
      }
      requestUser.filter = new UserFilter(
          null, this.email,null,null,null,null,null,null
      );

      AdminService.getUsersList(requestUser).then((data) => {
        this.UsersList = data.userList;
        this.page = data.page + 1
        this.totalElements = data.totalElements
      }).catch((error) => {
        console.log(error)
      });

      let requestPlan = new UserPlanRequest(
          this.pageUserPlans - 1,
          this.sizeUserPlans
      );
      if (this.sortColumnUserPlans != null) {
        requestPlan.sort = new Sort(this.sortColumnUserPlans, this.sortDirectionUserPlans);
      }else{
        requestPlan.sort = new Sort('stripePaidAmount', 'DESC');
      }
      requestPlan.filter = new UserPlanFilter(null,null,this.email,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null);

      AdminService.getUserPlanList(requestPlan).then((data) => {
        this.userPlansList = data.userPlanList.map(p => {
          const meta = this.determinePaymentMeta(p);
          return {
            ...p,
            paymentMethod: meta.paymentMethod,
            configurationId: meta.configurationId,
          };
        });

        this.pageUserPlans = data.page + 1
        this.totalElementsUserPlans = data.totalElements
      }).catch((error) => {
        if (error.response) {
          this.errorMessage = error.response.data.message;
        }
        console.log(error)
      });


      let requestSession = new SessionRequest(
          this.pageSessions - 1,
          this.sizeSession
      );
      if (this.sortColumnSessions != null) {
        requestSession.sort = new Sort(this.sortColumnSessions, this.sortDirectionSessions);
      }
      requestSession.filter = new SessionFilter(
          null, null, this.email,null,null,null,null,null,null,null,null,null,null,null
      );
      AdminService.getSessions(requestSession).then((data) => {
        this.sessionList = data.sessionList;
        this.pageSessions = data.page + 1
        this.totalElementsSessions = data.totalElements
        }).catch((error) => {
        if (error.response) {
          this.errorMessage = error.response.data.message;
        }
        console.log(error)
      });
      AdminService.getDevices(this.email).then((data) => {
      this.deviceList = data
      }).catch((error) => {
        if (error.response) {
          this.errorMessage = error.response.data.message;
        }
        console.log(error)
      });
    },
    isBlank(v) {
      return v === null || v === undefined || String(v).trim() === '';
    },

    determinePaymentMeta(plan) {
      if (!plan) return { paymentMethod: null, configurationId: null };

      // cPay: explicit boolean flag takes highest priority
      if (plan.cpayPayment === true) {
        return { paymentMethod: PaymentMethod.CPay, configurationId: null };
      }

      const stripeInvoice = (plan.stripeInvoice ?? "").toString().trim();
      const squareOrderId = (plan.squareOrderId ?? "").toString().trim();

      // Square: squareOrderId is set and matches stripeInvoice
      if (!this.isBlank(squareOrderId) && squareOrderId === stripeInvoice) {
        const configurationId = !this.isBlank(plan.squareConfigurationId) ? plan.squareConfigurationId : null;
        if (!configurationId) {
          return { paymentMethod: `ERROR_MISSING_${PaymentMethod.Square}_CONFIG`, configurationId: null };
        }
        return { paymentMethod: PaymentMethod.Square, configurationId };
      }

      if (this.isBlank(stripeInvoice)) {
        return { paymentMethod: null, configurationId: null };
      }

      const isStripe = stripeInvoice.startsWith("in_");
      const hasPlisio = !this.isBlank(plan.plisioTxnId);
      const paypalCaptureId = (plan.paypalCaptureId ?? "").toString().trim();
      const isPayPal = !this.isBlank(paypalCaptureId) && paypalCaptureId === stripeInvoice;

      let paymentMethod;
      if (isStripe) paymentMethod = PaymentMethod.Stripe;
      else if (isPayPal) paymentMethod = PaymentMethod.PayPal;
      else if (hasPlisio) paymentMethod = PaymentMethod.Plisio;
      else paymentMethod = PaymentMethod.PayPal;

      let configurationId = null;
      if (paymentMethod === PaymentMethod.Stripe) configurationId = plan.stripeConfigurationId;
      else if (paymentMethod === PaymentMethod.Plisio) configurationId = plan.plisioConfigurationId;
      else configurationId = plan.paypalConfigurationId;

      if (this.isBlank(configurationId)) configurationId = null;
      if (!configurationId) {
        return { paymentMethod: `ERROR_MISSING_${paymentMethod}_CONFIG`, configurationId: null };
      }
      return { paymentMethod, configurationId };
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      await navigator.clipboard.writeText(originalText);
      this.highlightElement(event.target);
    },
    async selectId(event) {
      await navigator.clipboard.writeText(event);
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(table, column) {
      let sortColumn, sortDirection;
      if (table === 'userPlans') {
        sortColumn = this.sortColumnUserPlans;
        sortDirection = this.sortDirectionUserPlans;
      } else if (table === 'sessions') {
        sortColumn = this.sortColumnSessions;
        sortDirection = this.sortDirectionSessions;
      }
      if (sortColumn === column) {
        sortDirection = sortDirection === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortColumn = column;
        sortDirection = 'ASC';
      }
      if (table === 'userPlans') {
        this.sortColumnUserPlans = sortColumn;
        this.sortDirectionUserPlans = sortDirection;
      } else if (table === 'sessions') {
        this.sortColumnSessions = sortColumn;
        this.sortDirectionSessions = sortDirection;
      }
      this.doLoadData()
    },
    updateItemsPerPage() {
      this.doLoadData()
    },
    onSelect() {
      if (this.searchEmail) {
        router.push({name: 'UserProfile', params: {email: this.searchEmail},});
      }
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css">
@import '../src/assets/style.css';
</style>
